import { AgentModel, Conversation } from "@/types";
import { createContext } from "react";

// Context Type
export type AppContextType = {
  agentsModels: AgentModel[];
  refreshAllAgentModels: () => Promise<void>;
  conversations: Conversation[];
  refreshAllConversations: () => Promise<void>;
  selectedAgentModel: AgentModel | null;
  setSelectedAgentModel: (agentModel: AgentModel | null) => void;
  addConversation: (conversation: Conversation) => void;
  updateConversation: (conversation: Conversation) => void;
};

// Default State for the context
export const defaultState: AppContextType = {
  agentsModels: [],
  refreshAllAgentModels: () => Promise.resolve(),
  conversations: [],
  refreshAllConversations: () => Promise.resolve(),
  selectedAgentModel: null,
  setSelectedAgentModel: () => {},
  addConversation: () => {},
  updateConversation: () => {},
};

export const AppContext = createContext<AppContextType>(defaultState);
